import Vue from 'vue';

export function observeDom(el: Element | Vue | null, callback: () => void, options: { subtree: boolean }) {
    const mutationObserver = MutationObserver;
    const eventListenerSupported = window.addEventListener != null;

    el = el ? ((el as Vue).$el || el) : null;

    if (!el || el.nodeType !== Node.ELEMENT_NODE) {
        return null;
    }

    let observer = null;

    if (mutationObserver) {
        observer = new mutationObserver((mutations: Array<MutationRecord>) => {
            let changed: boolean = false;

            for (const mutation of mutations) {
                const type = mutation.type;
                const target = mutation.target;

                if (type === 'characterData' && target.nodeType === Node.TEXT_NODE) {
                    changed = true;
                } else if (type === 'attributes') {
                    changed = true;
                } else if (type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
                    changed = true;
                }
            }

            if (changed) {
                callback();
            }
        });

        observer.observe(el, Object.assign({ childList: true, subtree: true}, options));
    } else if (eventListenerSupported) {
        // @ts-ignore
        el.addEventListener('DOMNodeInserted', callback, false);
        // @ts-ignore
        el.addEventListener('DOMNodeRemoved', callback, false);
    }

    return observer;
}
